import { defineMessages, type MessageDescriptor } from 'react-intl-next';

export const messages: Record<string, MessageDescriptor> = defineMessages({
	genericPermissionsStateHeading: {
		id: 'project-picker.request-access.generic-heading',
		defaultMessage: 'Get started with projects',
		description:
			'Heading displayed on picker when projects are not available in the site or user has not access to projects',
	},
	turnOnProjectsDescription: {
		id: 'project-picker.request-access.turn-on-projects-description',
		defaultMessage:
			'Link work items to a project for a clearer view of your team’s progress and an easier way to share updates.',
		description: 'Description to turn on projects',
	},
	requestAccessDescription: {
		id: 'project-picker.request-access.request-access-description',
		defaultMessage:
			'Ask your admin for access to projects so you can track work and share updates with your team.',
		description: 'Description to request access',
	},
	turnOnProjectsButtonLabel: {
		id: 'project-picker.request-access.turn-on-projects-button-label',
		defaultMessage: 'Turn on projects',
		description: 'Label for button to turn on projects',
	},
	requestAccessLink: {
		id: 'project-picker.request-access.request-access-link',
		defaultMessage: 'Request access',
		description: 'Label for link to request access',
	},
	requestAccessHeading: {
		id: 'project-picker.request-access.restricted-project-heading',
		defaultMessage: 'Get access to the Projects app',
		description: 'Heading displayed on picker when user has no access to the Project App',
	},
	requestAccessFullDescription: {
		id: 'project-picker.request-access.restricted-project-description',
		defaultMessage: 'To view and track work in this project, you’ll need access from your admin.',
		description: 'Description displayed on picker when user has no access to the Project App',
	},
});
